import { Field, Input, makeStyles, Textarea } from '@fluentui/react-components';
import { DocumentHeaderFilled } from '@fluentui/react-icons';
import { FormikHelpers, useFormik } from 'formik';
import { forwardRef, useImperativeHandle } from 'react';
import { StoryForm, StoryFormValidationSchema } from './types ';

export interface NewStoryFormRef {
	submitForm: () => void;
}

interface NewStoryFormProps {
	submit: (
		formValues: StoryForm,
		formikHelpers: FormikHelpers<StoryForm>
	) => void;
}

const NewStoryForm = forwardRef<NewStoryFormRef, NewStoryFormProps>(
	(props, ref) => {
		const styles = useStyles();

		const formik = useFormik<StoryForm>({
			initialValues: { header: '', content: '' },
			validationSchema: StoryFormValidationSchema,
			onSubmit: props.submit
		});

		useImperativeHandle(ref, () => ({
			submitForm: formik.submitForm
		}));

		return (
			<div style={{ width: '100%', height: '100%' }}>
				<form
					id='story-form'
					onSubmit={formik.handleSubmit}
				>
					<Field
						label={'Header'}
						validationState={
							formik.touched.header && formik.errors.header
								? 'error'
								: 'none'
						}
						validationMessage={formik.errors.header}
						className={styles.field}
					>
						<Input
							id='header'
							name='header'
							value={formik.values.header}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							placeholder='Required'
							contentBefore={<DocumentHeaderFilled />}
							size='large'
						/>
					</Field>

					<Field
						label={'Content'}
						validationState={
							formik.touched.content && formik.errors.content
								? 'error'
								: 'none'
						}
						validationMessage={formik.errors.content}
						className={styles.field}
					>
						<Textarea
							id='content'
							name='content'
							value={formik.values.content}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							size='large'
							style={{ height: '135px' }}
						/>
					</Field>
				</form>
			</div>
		);
	}
);

export default NewStoryForm;

const useStyles = makeStyles({
	field: {
		'& .fui-Field__validationMessage': {
			display: 'flex',
			alignItems: 'center'
		}
	}
});
